"use client";

import React, { useState } from "react";
import PlusCircle from "../svg/plus-circle";
import MinusCircle from "../svg/minus-circle";

interface FAQProps {
    faqData: Array<{
        question: string;
        answer: string;
    }>;
}


const FAQ: React.FC<FAQProps> = ({ faqData }) => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    
    const toggleFAQ = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="space-y-4">
            {faqData.map((item, index) => (
                <div key={index} className={`rounded-2xl overflow-hidden ${activeIndex === index ? "border-violet-50 border-2" : ""}`}>
                    <div
                        className={`px-8 max-[576px]:px-[20px] cursor-pointer duration-200 ${activeIndex === index ? "bg-white text-black " : "bg-blue-500 bg-blue-gradient"
                            }`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className={`flex justify-between gap-2 items-center py-4  max-[576px]:py-[12px] ${activeIndex === index ? "border-dotted border-violet-100 border-b-2 " : ""} `}>
                            <span className={`text-2xl font-bold ${activeIndex === index ? "text-black-50 " : "text-white"} max-[576px]:text-[16px] `}>{item.question}</span>
                                {activeIndex === index ? (
                                    <div className="min-w-[40px] min-h-[40px]">
                                        <div className="mobicon">
                                            <PlusCircle/>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="min-w-[40px] min-h-[40px]">
                                        <div className="mobicon">
                                            <MinusCircle />
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                    {activeIndex === index && (
                        <div className="px-8 p-4 bg-white leading-[133%] text-gray-900 text-lg font-normal" dangerouslySetInnerHTML={{ __html: item.answer }} />
                    )}
                </div>
            ))}
        </div>
    );
};

export default FAQ;

